$(document).ready(function () {

	// we need to make sure the cloned slides dont end up in fancybox
	// remove data-fancybox from clones
	$('[data-fancybox]').each(function() {
		if ($(this).closest('.slick-cloned').length > 0) {
			$(this).addClass('is-clone');
	
		}
	});
	// collect unique data-fancybox group names (excluding clones)
	var groups = [];
	$('[data-fancybox]:not(.is-clone)').each(function () {
		var group = $(this).attr('data-fancybox');
		if (group && groups.indexOf(group) === -1) {
			groups.push(group);
		}
	});

	$.each(groups, function (index, group) {
		$(document).fancybox({

			selector: '[data-fancybox="' + group + '"]:not(.is-clone)',

			preventCaptionOverlap: true,

		// What buttons should appear in the top right corner.
		buttons: [
			"fullScreen",
			"close"
		],
		image: {
			// Wait for images to load before displaying
			preload: true
		},

		// Open/close animation type
		animationEffect: "fade",

		// Duration in ms for open/close animation
		animationDuration: 600,

		// Transition effect between slides
		transitionEffect: "fade",

		// Duration in ms for transition animation
		transitionDuration: 400,

		// =============================================
		// Clicks
		// =============================================

		// Clicked on the content
		clickContent: function (current, event) {
			return current.type === "image" ? "zoom" : false;
		},

		// Clicked on the slide
		clickSlide: "close",

		// Clicked on the background
		// if you have not changed the layout, then most likely you need to use `clickSlide` option
		clickOutside: "close",

		// Same as previous two, but for double click
		dblclickContent: function (current, event) {
			return current.type === "image" ? "zoom" : false;
		},
		dblclickSlide: "close",
		dblclickOutside: "close",

		// Clicks when mobile device is detected
		mobile: {
			preventCaptionOverlap: false,
			idleTime: false,
			clickContent: function (current, event) {
				return current.type === "image" ? "toggleControls" : false;
			},
			clickSlide: function (current, event) {
				return current.type === "image" ? "toggleControls" : "close";
			},
			dblclickContent: function (current, event) {
				return current.type === "image" ? "zoom" : false;
			},
			dblclickSlide: function (current, event) {
				return current.type === "image" ? "zoom" : false;
			}
		},

		// =============================================
		// Templates
		// =============================================
/*
		baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
			'<div class="fancybox-bg"></div>' +
			'<div class="fancybox-inner">' +
			'<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
			'<div class="fancybox-toolbar">{{buttons}}</div>' +
			'<div class="fancybox-navigation">{{arrows}}</div>' +
			'<div class="fancybox-stage"></div>' +
			'<div class="fancybox-caption"></div>' +
			'</div>' +
			'</div>',
*/

		// Loading indicator template
		// spinnerTpl: '<div class="fancybox-loading"></div>',

		// Error message template
		// errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',

		btnTpl: {
			download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
				'<svg class="icon icon--mail" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#mail" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#mail"></use>' +
				'</svg>' +
				'</a>',

			zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}">' +
				'<svg class="icon icon--zoom-in" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#zoom-in" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#zoom-in"></use>' +
				'</svg>' +
				'</button>',

			close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
				'<svg class="icon icon--cross" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#cross" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#cross"></use>' +
				'</svg>' +
				'</button>',

			fullScreen: '<button data-fancybox-fullscreen="" class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}">' +
				'<svg class="icon icon--fullscreen-enter" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#fullscreen-enter" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#fullscreen-enter"></use>' +
				'</svg>' +
				'<svg class="icon icon--fullscreen-exit" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#fullscreen-exit" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#fullscreen-exit"></use>' +
				'</svg>' +
				'</button>',

			arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
				'<svg class="icon icon--arrow-left" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-left" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-left"></use>' +
				'</svg>' +
				'</button>',

			arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
				'<svg class="icon icon--arrow-right" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-right" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-right"></use>' +
				'</svg>' +
				'</button>',

			// This small close button will be appended to your html/inline/ajax content by default,
			// if "smallBtn" option is not set to false
			smallBtn: '<button type="button" data-fancybox-cross class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
				'<svg class="icon icon--cross" role="presentation" aria-hidden="true">' +
				'<use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#cross" xlink:href="assets/iconsprite/symbol/svg/sprite.symbol.svg#cross"></use>' +
				'</svg>' +
				'</button>',
		},
/*
		beforeShow: function () {

			var credits = '';


			var obj = $(this.element);
			var credits = obj.attr('data-credits');
			// 			var credits = obj.data("credits");

			// console.log('object: ' + obj);

			// console.log('credits: ' + credits);

			obj.find('.fancybox-caption__body').append(
				document.createTextNode('credits')
			);

		},
*/

		// Internationalization
		// ====================

		lang: "de",
		i18n: {
			en: {
				CLOSE: "Close",
				NEXT: "Next",
				PREV: "Previous",
				ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
				PLAY_START: "Start slideshow",
				PLAY_STOP: "Pause slideshow",
				FULL_SCREEN: "Full screen",
				THUMBS: "Thumbnails",
				DOWNLOAD: "Download",
				SHARE: "Share",
				ZOOM: "Zoom"
			},
			de: {
				CLOSE: "Schliessen",
				NEXT: "Weiter",
				PREV: "Zurück",
				ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
				PLAY_START: "Diaschau starten",
				PLAY_STOP: "Diaschau beenden",
				FULL_SCREEN: "Vollbild",
				THUMBS: "Vorschaubilder",
				DOWNLOAD: "Herunterladen",
				SHARE: "Teilen",
				ZOOM: "Maßstab"
			}
		}
	});
	});

});


